import {
  ADD_BASIC_CONTENT,
  ADD_BASIC_CONTENT_FAILED,
  ADD_BASIC_CONTENT_SUCCESS,
  GET_BASIC_CONTENT,
  GET_BASIC_CONTENT_FAILED,
  GET_BASIC_CONTENT_LIST,
  GET_BASIC_CONTENT_LIST_FAILED,
  GET_BASIC_CONTENT_LIST_SUCCESS,
  GET_BASIC_CONTENT_SUCCESS,
  RESET_BASIC_CONTENT,
  RESET_BASIC_CONTENT_LIST,
  UPDATE_BASIC_CONTENT,
  UPDATE_BASIC_CONTENT_FAILED,
  UPDATE_BASIC_CONTENT_SUCCESS,
} from "./actionTypes"

export const addBasicContent = params => ({
  type: ADD_BASIC_CONTENT,
  payload: params,
})

export const addBasicContentSuccess = response => ({
  type: ADD_BASIC_CONTENT_SUCCESS,
  payload: response,
})

export const addBasicContentFailed = error => ({
  type: ADD_BASIC_CONTENT_FAILED,
  payload: error,
})

export const getBasicContent = params => ({
  type: GET_BASIC_CONTENT,
  payload: params,
})

export const getBasicContentSuccess = response => ({
  type: GET_BASIC_CONTENT_SUCCESS,
  payload: response,
})

export const getBasicContentFailed = error => ({
  type: GET_BASIC_CONTENT_FAILED,
  payload: error,
})

export const resetBasicContent = () => ({
  type: RESET_BASIC_CONTENT,
  payload: {},
})

export const updateBasicContent = (params, id) => ({
  type: UPDATE_BASIC_CONTENT,
  payload: { params, id },
})

export const updateBasicContentSuccess = response => ({
  type: UPDATE_BASIC_CONTENT_SUCCESS,
  payload: response,
})

export const updateBasicContentFailed = error => ({
  type: UPDATE_BASIC_CONTENT_FAILED,
  payload: error,
})

export const getBasicContentList = params => ({
  type: GET_BASIC_CONTENT_LIST,
  payload: params,
})

export const getBasicContentListSuccess = response => ({
  type: GET_BASIC_CONTENT_LIST_SUCCESS,
  payload: response,
})

export const getBasicContentListFailed = error => ({
  type: GET_BASIC_CONTENT_LIST_FAILED,
  payload: error,
})

export const resetBasicContentList = () => ({
  type: RESET_BASIC_CONTENT_LIST,
  payload: {},
})
